module.exports = __webpack_public_path__ + "img/np.b66578a5.svg";